module.exports = __webpack_public_path__ + "img/company.88eb8d6d.png";